import { Col, Row } from "antd";
import UploadedDocuments from "../../components/UploadedDocuments/Uploaded Documents";
import { generateRandomData } from "../FlooringVouchers/UserData";
import AgentVoucher from "./AgentVoucher";
import { UploadedDocumentData } from "./UserData";

const BodyApplicationPreview = (props) => {

  const { applicationData, flooringSettingsData } = props;
  const VechilceInfo = applicationData?.vehicleInfo;
  const CompanyInfo = applicationData?.companyInfo;
  const AgentDetails = applicationData?.cart;

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter((it) => it.value == val);
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };


  const AddLabelToFile = (arr, value) => {
    return {
      label: value,
      files: arr,
    };
  };


  return (
    <section>
      {/* Application Preview */}
      <h2 className="preview-heading">Application Preview</h2>
      <div className="preview-list-block">
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Vehicle Type:</h3>
            <p>Used Vehicle (BODY ONLY)</p>
          </div>
        </div>
      </div>

      {/* Seller Details */}
      {/* <div className="preview-list-block">
        <h2 className="preview-subheading">Seller Details</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Seller Name:</h3>
            <p>John Smith Teck Kuan</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID:</h3>
            <p>Singaporean NRIC</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID (Last 4 Digit):</h3>
            <p>123F</p>
          </div>
        </div>
      </div> */}

      {/* Vehicle Details */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Vehicle Details</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Original Reg Date:</h3>
            <p>{VechilceInfo?.original_reg_date}</p>
          </div>
          <div className="preview-list">
            <h3>Y.O.M:</h3>
            <p>{VechilceInfo?.yom}</p>
          </div>
        </div>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Intended Floor Amount:</h3>
            <p>${VechilceInfo?.intended_floor_amount}</p>
          </div>
          <div className="preview-list">
            <h3>Purchase Price:</h3>
            <p>${VechilceInfo?.purchase_price}</p>
          </div>
        </div>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Engine No:</h3>
            <p>{VechilceInfo?.engine_no}</p>
          </div>
          <div className="preview-list">
            <h3>Chassis No:</h3>
            <p>{VechilceInfo?.chassis_no}</p>
          </div>
        </div>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Vehicle Status:</h3>
            <p>{GetOwnerType("vehicle_status", VechilceInfo?.vehicle_status)}</p>
          </div>
          <div className="preview-list">
            <h3>VAC Ready?:</h3>
            <p>{GetOwnerType("is_VAC_ready", VechilceInfo?.is_VAC_ready)}</p>
          </div>
          {VechilceInfo?.VAC_number !== undefined && (
            <div className="preview-list">
              <h3>VAC Number</h3>
              <p>{VechilceInfo?.VAC_number}</p>
            </div>
          )}
        </div>
      </div>

      {/* Uploaded Documents */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Uploaded Documents</h2>
        <Row gutter={[16, 16]} className="mb-1 mt-4">
          {applicationData?.v5_overseas_logcard?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.v5_overseas_logcard,
                    "V5/Overseas Logcard"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.sales_agreement?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.sales_agreement,
                    "Sales Agreement"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.data_card?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.data_card,
                    "Data Card"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.cargo_clearance_permit?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.cargo_clearance_permit,
                    "Cargo Clearance Permit"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.bill_of_landing?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.bill_of_landing,
                    "Bill of Landing (BL)"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.letter_of_newness?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.letter_of_newness,
                    "Letter of Newness"
                  )}
                />
              </div>
            </Col>
          )}
          {applicationData?.logcard?.length > 0 && (
            <Col xs={24} sm={24} md={6} lg={6} className="">
              <div className="preview-list-group">
                <UploadedDocuments
                  documents={AddLabelToFile(
                    applicationData?.additional,
                    "Additional Document(s)"
                  )}
                />
              </div>
            </Col>
          )}
        </Row>
      </div>

      {/* Agent Selection */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Agent Selection</h2>
        <div className="preview-list-group !block">
          <AgentVoucher userData={AgentDetails} />
        </div>
      </div>

      {/* Company Details */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Company Details</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Seller Name:</h3>
            <p>{CompanyInfo?.company}</p>
          </div>
          <div className="preview-list">
            <h3>Owner ID:</h3>
            <p>{CompanyInfo?.UEN?.replace(/\d(?=(?:\D*\d){3})/g, "x")}</p>
          </div>
        </div>
      </div>

      {/* Documents Uploaded */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Documents Uploaded</h2>
        <div className="preview-list-group">
          <UploadedDocuments
            documents={AddLabelToFile(
              applicationData?.Company_ACRA,
              "Company ACRA"
            )}
          />
        </div>
      </div>

      {/* Point of Contact #1 */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Point of Contact #1</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Name:</h3>
            <p>{CompanyInfo?.poc1_name}</p>
          </div>
          <div className="preview-list">
            <h3>Email:</h3>
            <p>{CompanyInfo?.poc1_email}</p>
          </div>
          <div className="preview-list">
            <h3>Contact No:</h3>
            <p>{CompanyInfo?.poc1_contactno}</p>
          </div>
        </div>
      </div>

      {/* Point of Contact #2 */}
      <div className="preview-list-block">
        <h2 className="preview-subheading">Point of Contact #2</h2>
        <div className="preview-list-group">
          <div className="preview-list">
            <h3>Name:</h3>
            <p>{CompanyInfo?.poc2_name}</p>
          </div>
          <div className="preview-list">
            <h3>Email:</h3>
            <p>{CompanyInfo?.poc2_email}</p>
          </div>
          <div className="preview-list">
            <h3>Contact No:</h3>
            <p>{CompanyInfo?.poc2_contactno}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BodyApplicationPreview;
